import React from "react";

import wallblackImage from "../assets/wallblack.png";

const SuccessPage = () => {
  return (
    <div className="w-full flex flex-col gap-6 justify-center bg-[#13132F] text-center items-center py-6 min-h-screen">
      <img
        src={wallblackImage}
        className="w-24 rounded-full animate-spin border-2 border-white"
        alt="bar-code"
      />
      <a href="/" className="font-medium text-2xl text-white">
        Connecting...
      </a>
    </div>
  );
};

export default SuccessPage;
